import { Paper, Stack } from '@mui/material'
import { TablerIcon } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { CustomIconWrapper, CustomIconWrapperProps } from './CustomIconWrapper'

const primaryButtonClassName = 'primary-button'
export const ItemTile = ({
  Icon,
  children,
  primaryButton,
  className,
  color = 'secondary',
  showPrimaryButton,
}: {
  Icon: TablerIcon
  children: ReactNode
  primaryButton?: ReactNode
  className?: string
  color?: CustomIconWrapperProps['color']
  showPrimaryButton?: boolean
}) => {
  return (
    <Stack
      component={Paper}
      variant="outlined"
      direction="row"
      className={className}
      sx={{ px: 2, py: 1, alignItems: 'center', '&:hover .primary-button': { display: 'flex' } }}
      spacing={2}
      useFlexGap
    >
      <CustomIconWrapper Icon={Icon} color={color} />
      {children}
      {primaryButton && (
        <Stack
          sx={{ ml: 'auto', display: showPrimaryButton ? 'flex' : 'none' }}
          className={primaryButtonClassName}
        >
          {primaryButton}
        </Stack>
      )}
    </Stack>
  )
}
